import { crc32 } from "./crc32";

export const OpCode = {
  createAttestation: crc32("create_attestation"),
  updateAttestation: crc32("update_attestation"),
};
